import type { CSSProperties } from 'react'

/** Стиль с пользовательскими CSS-переменными: ключи `--имя` проверяются типом, приведение `as CSSProperties` не нужно. */
export type CssVarStyle = CSSProperties & Record<`--${string}`, string>

/** Доля хода (0–1) как оборот кольца: `--photo-progress` читают стили кольца загрузки фото. */
export function photoProgressStyle(fraction: number | undefined): CssVarStyle {
  return { '--photo-progress': `${fraction ?? 0}turn` }
}
